import { z } from '@exodus/zod';
import { memoize } from '@exodus/basic-utils';
const createRemoteConfigReport = ({ remoteConfigAtom, }) => ({
    namespace: 'remoteConfig',
    export: async () => {
        const { remoteConfigUrl, config } = await remoteConfigAtom.get();
        return { loaded: Boolean(config), remoteConfigUrl, gitHash: config?.meta?.gitHash };
    },
    getSchema: memoize(() => z
        .object({
        remoteConfigUrl: z.string().nullish(),
        loaded: z.boolean(),
        gitHash: z
            .string()
            .regex(/^[\da-f]{5,40}$/u)
            .nullish(),
    })
        .strict()),
});
const remoteConfigReportDefinition = {
    id: 'remoteConfigReport',
    type: 'report',
    factory: createRemoteConfigReport,
    dependencies: ['remoteConfigAtom'],
    public: true,
};
export default remoteConfigReportDefinition;
